module.exports = __webpack_public_path__ + "static/media/Morocco_Spain.57dae924.jpeg";